import React, { useState, useEffect } from "react";

import RecentHistory from "./CommonJobBoardTabs/RecentHistory";
import SavedHistory from "./CommonJobBoardTabs/SavedHistory";
import {
  Button,
  LogoLoader,
  showToast,
  useFormHandler,
} from "../../../components";
import { useDispatch, useSelector } from "react-redux";
import { fetchMonsterClassicStart } from "../../../redux/slices/bdmjobs/bdmjobsSlice";
import ClassicSearch from "./Monster/ClassicSearch";
import PowerSearch from "./Monster/PowerSearch";
import MonsterSearch from "./Monster/MonsterSearch";
import { useLoginUser } from "../../../hooks/useLoginUser";
import { setMonsterAccessidStart } from "../../../redux/slices/internalDbES/internalDbESlice";
const Monster = () => {
  const dispatch = useDispatch();
  const { loginUserUiid } = useLoginUser();
  // const loading = useSelector((state) => state.bdmJobs?.loading);
  const [loading, setLoading] = useState(false);
  const data = useSelector(
    (state) => state.bdmJobs?.jobBoards.monster.classic.data
  );
  const [loadMonster, setLoadMonster] = useState(false);
  const [saveAccessId, setSaveAccessId] = useState(0);
  const [checkboxValues, setCheckboxValues] = useState([]);
  const { accessData } = useSelector((state) => state.internalDbES);
  const fetchIntegrationAccess = () => {
    try {
      const params = {
        coll: "IntegrationAccess",
        fil: {
          userId: {
            type: "FIND_INTIGRATION_ACCESS",
            value: loginUserUiid,
            category: 3,
            categoryType: 1,
            status: 1,
          },
        },
        useAggregate: true,
      };

      dispatch(setMonsterAccessidStart(params));
    } catch (err) {
      console.error("Error fetching integration access:", err);
    }
  };

  useEffect(() => {
    if (loginUserUiid) {
      fetchIntegrationAccess();
    }
  }, [loginUserUiid]);

  useEffect(() => {
    const status = accessData?.monster?.[0]?.integrationData?.status;
    const accessId = accessData?.monster?.[0]?.uiid;

    if (typeof status !== "undefined") {
      setSaveAccessId(accessId);
      if (status === 1) {
        setLoadMonster(true);
      } else {
        showToast(
          "Monster integration access not found. Please contact the administrator",
          "error"
        );
      }
    }
  }, [accessData]);
  const buttons = [
    { id: "classic", title: "Classic Search" },
    { id: "power", title: "Power Search" },
    { id: "monster", title: "Monster Search" },
  ];
  const handleCheckboxChange = (selectedValues) => {
    setCheckboxValues(selectedValues);
  };
  const [activeButton, setActiveButton] = useState(buttons[0].id);
  const [showButtons, setShowButtons] = useState(true);

  const monsterMenus = [
    {
      title: "Recent History",
      page: <RecentHistory board="monster" subBoard="classic" />,
      type: "main",
    },
    {
      title: "Saved History",
      page: <SavedHistory board="monster" subBoard="classic" />,
      type: "main",
    },
  ];
  const initialFormData = {
    jobTitleOrKeyword: "",
    from: "",
    to: "",
    location: "",
    country: "",
    state: "",
    distance: "",
    zipCode: "",
    includeDetails: "",
    mosTRecentEmployer: "",
    mostRecentJobTitle: "",
    mostRecentDescription: "",
    schoolAttended: "",
    minimum: "",
    maximum: "",
    perYear: "",
    showResumes: "",
    jobSeekerProfile: "",
    moreProfileOptions: "",
    languageProficiency: "",
    proficiencyLevel: "",
    industries: "",
    jobStatus: "",
    jobType: "",
  };
  const { formData, errors, handleChange, validateAllFields, setFormData } =
    useFormHandler(initialFormData, {
      jobTitleOrKeyword: {
        type: "text",
        required: true,
      },
    });

  const handleSearch = async () => {
    if (!formData.jobTitleOrKeyword) {
      showToast("Please enter a Job Title or Keyword.", "error");
      return;
    }
    setLoading(true);
    const requestBody = {
      accessId: 5,
      searchType: "classic",
      payload: {
        query: { q: formData.jobTitleOrKeyword },
        page: 1,
        limit: 30,
        source: 3, // for classic
      },
    };

    dispatch(fetchMonsterClassicStart(requestBody));
    setLoading(false);
  };
  if (loading) {
    return (
      <div className="flex justify-center items-center h-screen">
        <LogoLoader />
      </div>
    );
  }
  return (
    <div className="flex flex-col flex-1 min-h-0 overflow-auto py-3">
      {showButtons && (
        <div className="flex justify-center">
          <div className="flex gap-10 my-2 bg-primary-50 overflow-hidden flex-1 max-w-fit border border-primary-200 rounded-full p-0.6">
            {buttons.map((btn, index) => (
              <div key={index}>
                <Button
                  key={btn.id}
                  title={btn.title}
                  className={`min-w-[200px] !py-3 rounded-full
                }`}
                  style={
                    activeButton === btn.id
                      ? { boxShadow: "inset 0 0 9px #8f8181ff" }
                      : undefined
                  }
                  variant={activeButton === btn.id ? "contained" : "text"}
                  onClick={() => setActiveButton(btn.id)}
                />
              </div>
            ))}
          </div>
        </div>
      )}

      {activeButton === "classic" ? (
        <ClassicSearch
          loadMonster={loadMonster}
          setShowButtons={setShowButtons}
          saveAccessId={saveAccessId || accessData?.monster?.[0]?.uiid}
        />
      ) : activeButton === "power" ? (
        <PowerSearch
          loadMonster={loadMonster}
          saveAccessId={saveAccessId || accessData?.monster?.[0]?.uiid}
          setShowButtons={setShowButtons}
        />
      ) : (
        <MonsterSearch
          loadMonster={loadMonster}
          saveAccessId={saveAccessId || accessData?.monster?.[0]?.uiid}
          setShowButtons={setShowButtons}
        />
      )}
    </div>
  );
};

export default Monster;
